import { isMobile, isIOS, isAndroid } from "react-device-detect";
import { REDIRECT_URL } from "./constants";
import paths from "./paths";

const { base, ios, android } = REDIRECT_URL;

function RedirectToDownload() {
	if (isMobile) {
		if (isIOS) {
			window.location.replace(ios);
		} else if (isAndroid) {
			window.location.replace(android);
		} else {
			window.location.replace(base);
		}
	} else {
		window.location.replace(paths.home);
	}

	return (
		null
	);
}

export default RedirectToDownload;
